import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const conteneur = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Page pré-rendue au build (scripts/prerender.js) : on reprend le HTML
// existant ; en développement, la page est construite dans le navigateur.
if (conteneur.hasChildNodes()) {
  ReactDOM.hydrateRoot(conteneur, app);
} else {
  ReactDOM.createRoot(conteneur).render(app);
}
